import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapAtmToApiAtmDto = (values: ICreateAtmForm): IPostNewAtm | {} => {
  let dataMapping: IPostNewAtm;
  const unknown = -1;

    dataMapping = {
      description: values.description,
      atmAddress: values.atmAddress,
      atmHost: values.atmHost,
      unitID: +values.unitID,
      linetypeID: +values.linetypeID !== 0 ? +values.linetypeID : unknown,
      modemID: +values.modemID !== 0 ? +values.modemID : unknown,
      atmTypeID: +values.atmTypeID !== 0 ? +values.atmTypeID : unknown,
      atmTerm: values.atmTerm,
      connMethod: values.connMethod,
      contact: values.contact,
      atmModelID: +values.atmModelID !== 0 ? +values.atmModelID : unknown,
      atmCompany: +values.atmCompany !== 0 ? +values.atmCompany : unknown,
      isEmporiki: values.isEmporiki,
      isCiti: values.isCiti,
      deleted:false

    }
  
  return dataMapping;
}


export const createAtm = ( {data} : {data: ICreateAtmForm }): Promise<string> => {
  const atm = mapAtmToApiAtmDto(data);
  return axiosDefaultApi.post(`/api/Atm/InsertAtm`, atm);
};

type QueryFnType = typeof createAtm;

type UseCreateAtmOptions = {
  data: IPostNewAtm | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateAtm = ({ config }: UseCreateAtmOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του ΑΤΜ.`, 500);
            console.error('Couldnt create new atm', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtms"])
            addNotification(`Το ΑΤΜ Δημιουργήθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createAtm,
    })
}